import { Injectable, Type } from '@angular/core';
import { UnitsDistributionBase } from '../base/units-distribution.base';

type ComponentType = Type<UnitsDistributionBase>;

@Injectable({
  providedIn: 'root'
})
export class UnitsDistributionRegistry {
  private registry = new Map<string, ComponentType>();

  /**
   * Register a component for a specific sport/type combination
   */
  register(sportCode: string, typeCode: string, component: ComponentType): void {
    const key = this.getKey(sportCode, typeCode);
    this.registry.set(key, component);
  }

  /**
   * Get component for a specific sport/type combination
   */
  getComponent(sportCode: string, typeCode: string): ComponentType {
    const key = this.getKey(sportCode, typeCode);
    const component = this.registry.get(key);
    
    if (!component) {
      throw new Error(`No component registered for ${key}`);
    }
    
    return component;
  }

  /**
   * Check if a component exists for a specific sport/type combination
   */
  hasComponent(sportCode: string, typeCode: string): boolean {
    const key = this.getKey(sportCode, typeCode);
    return this.registry.has(key);
  }

  /**
   * Generate registry key from sport code and type code
   */
  private getKey(sportCode: string, typeCode: string): string {
    return `${sportCode}_${typeCode}`;
  }
}